import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { Col, Flex, Form, Input, message, Modal, Row, Space, Tag } from "antd";
import mqtt from "mqtt";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import API from "../../../services/api-request";
import { getDataLogin } from "../../../utils/getDataLogin";
import { isJSON } from "../../../utils/isJson";

const getStatusTagProps = (status) => {
  if (status === "Online") return { icon: <CheckCircleOutlined />, color: "success" };
  if (status === "Offline") return { icon: <CloseCircleOutlined />, color: "error" };
  return { icon: <SyncOutlined spin />, color: "warning" };
};

const Process = (props) => {
  const [rfidData, setRfidData] = useState(null);
  const [weightData1, setWeightData1] = useState(null);
  const [weightData2, setWeightData2] = useState(null);

  const [dataPallet, setDataPallet] = useState([]);
  const [selectedPallet, setSelectedPallet] = useState({});
  const [dataOperator, setDataOperator] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState({});
  const [selectedWeight1, setSelectedWeight1] = useState({ weight: 0 });
  const [selectedWeight2, setSelectedWeight2] = useState({ weight: 0 });

  const [selectedContainer, setSelectedContainer] = useState(null);
  const [gatewayStatus, setGatewayStatus] = useState("Connecting...");
  const [weight1Status, setWeight1Status] = useState("Connecting...");
  const [weight2Status, setWeight2Status] = useState("Connecting...");

  const handleCancelProcess = () => {
    props.setOpenProcess(false);
  };

  const handleOkProcess = () => {
    if (
      (selectedContainer === 0 && selectedWeight1.weight <= 0) ||
      (selectedContainer === 1 && selectedWeight2.weight <= 0)
    ) {
      message.error("Silakan pilih timbangan yang memiliki berat.");
      return;
    }

    props.onSelectedPallet(
      selectedPallet.id,
      selectedPallet,
      props.selectionIndex
    );
    props.setOpenProcess(false);
    props.handleOkProcess({
      pallet: { ...selectedPallet },
      operator: { ...selectedOperator },
      weight:
        selectedContainer === 0
          ? { ...selectedWeight1 }
          : { ...selectedWeight2 },
    });
    setSelectedPallet({});
    setSelectedOperator({});
    setSelectedWeight1({ weight: 0 });
    setSelectedWeight2({ weight: 0 });
    setSelectedContainer(null);
  };

  const url =
    "wss://b0eac2f8e0b142afaa45dcc44303a806.s1.eu.hivemq.cloud:8884/mqtt";
  const optionsMqtt = {
    username: "ravelware",
    password: "R4v3lw4r3",
    clean: true,
    connectTimeout: 10000,
    reconnectPeriod: 500,
    protocolVersion: 5,
  };

  useEffect(() => {
    getPallet();
    getOperator();

    const topics = [
      "WMS-LBF/STATUS/GATEWAY",
      "WMS-LBF/STATUS/WEIGHT/01",
      "WMS-LBF/STATUS/WEIGHT/02",
      "WMS-LBF/DATA/WEIGHT/01",
      "WMS-LBF/DATA/WEIGHT/02",
      getDataLogin()?.device === "device1" ? "WMS-LBF/DATA/READER/01" : "WMS-LBF/DATA/READER/02",
    ];

    const mqttClient = mqtt.connect(url, optionsMqtt);

    mqttClient.on("connect", () => {
      console.log("✅ Connected to MQTT broker");
      mqttClient.subscribe(topics, (err) => {
        if (!err) {
          console.log(`✅ Subscribed to topics: ${topics.join(", ")}`);
        } else {
          console.error("❌ Subscription error:", err);
        }
      });
    });

    mqttClient.on("message", (topic, message) => {
      try {
        const data = isJSON(message)
          ? JSON.parse(message.toString())
          : new TextDecoder().decode(message);

        switch (topic) {
          case "WMS-LBF/DATA/READER/01":
            console.log("📡 Data dari READER 01:", data);
            setRfidData(data);
            break;
          case "WMS-LBF/DATA/READER/02":
            console.log("📡 Data dari READER 02:", data);
            setRfidData(data);
            break;
          case "WMS-LBF/DATA/WEIGHT/01":
            console.log("⚖️ Data dari WEIGHT 01:", data);
            setWeightData1(data);
            break;
          case "WMS-LBF/DATA/WEIGHT/02":
            console.log("⚖️ Data dari WEIGHT 02:", data);
            setWeightData2(data);
            break;
          case "WMS-LBF/STATUS/GATEWAY":
            console.log("📡 Status dari GATEWAY:", data);
            setGatewayStatus(data);
            break;
          case "WMS-LBF/STATUS/WEIGHT/01":
            console.log("⚖️ Status dari WEIGHT 01:", data);
            setWeight1Status(data);
            break;
          case "WMS-LBF/STATUS/WEIGHT/02":
            console.log("⚖️ Status dari WEIGHT 02:", data);
            setWeight2Status(data);
            break;
          default:
            console.log("📩 Data dari topic lain:", topic, data);
        }
      } catch (error) {
        console.error("❌ Error parsing MQTT message:", error);
      }
    });

    mqttClient.on("error", (err) => {
      console.error("❌ Connection error:", err);
    });

    mqttClient.on("close", () => {
      console.warn("⚠️ MQTT connection closed");
    });

    mqttClient.on("offline", () => {
      console.warn("⚠️ MQTT is offline");
    });

    mqttClient.on("reconnect", () => {
      console.warn("🔄 Reconnecting...");
    });

    return () => {
      if (mqttClient) {
        console.log("🔌 Disconnecting from MQTT...");
        mqttClient.end();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (rfidData && dataPallet.length > 0 && dataOperator.length > 0) {
      let selectPallet = dataPallet.find((e) => e.rfid.number === rfidData.EPC);
      if (selectPallet) {
        setSelectedPallet(selectPallet);
      }

      let selectOperator = dataOperator.find(
        (e) => e.Rfid.number === rfidData.EPC
      );
      if (selectOperator) {
        setSelectedOperator(selectOperator);
      }
    }
  }, [dataPallet, dataOperator, rfidData]);

  useEffect(() => {
    if (weightData1) {
      setSelectedWeight1(weightData1);
    }
  }, [weightData1]);

  useEffect(() => {
    if (weightData2) {
      setSelectedWeight2(weightData2);
    }
  }, [weightData2]);

  const getPallet = async () => {
    try {
      const res = await API.Get(`pallet`);
      setDataPallet(res?.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const getOperator = async () => {
    try {
      const res = await API.Get(`user?id_privilege=6`);
      setDataOperator(res?.data || []);
    } catch (err) {
      console.log(err);
    }
  };

  const containerStyle = (index) => ({
    width: "100%",
    height: "100px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: `3px solid ${selectedContainer === index ? "#1890ff" : "gray"}`,
    cursor: "pointer",
    borderRadius: "8px",
  });

  const gatewayTag = getStatusTagProps(gatewayStatus);

  return (
    <Modal
      title={
        <Flex justify="space-between">
          <Space>Silahkan Tap RFID dan Timbang</Space>
          <Space style={{ marginRight: "2%", fontWeight: "normal" }}>
            <Tag icon={gatewayTag.icon} color={gatewayTag.color}>
              Gateway {gatewayStatus}
            </Tag>
          </Space>
        </Flex>
      }
      okText="Simpan"
      cancelText="Tutup"
      open={props.openProcess}
      onOk={handleOkProcess}
      onCancel={handleCancelProcess}
      okType={"primary"}
    >
      <Form name="Modal Form" layout="vertical">
        <Row gutter={[8, 8]}>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item label="Pallet">
              <Input
                placeholder="Pallet"
                value={selectedPallet.name}
                readOnly
                allowClear
              />
            </Form.Item>
          </Col>
          <Col lg={12} md={12} sm={12} xs={24}>
            <Form.Item label="Operator">
              <Input
                placeholder="Operator"
                value={selectedOperator.name}
                readOnly
                allowClear
              />
            </Form.Item>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <Form.Item label="Pilih Timbangan">
              <div style={{ display: "flex", gap: "10px" }}>
                {[0, 1].map((index) => {
                  const currentStatus = index === 0 ? weight1Status : weight2Status;
                  const tagProps = getStatusTagProps(currentStatus);

                  return (
                    <button
                      type="button"
                      key={index}
                      style={{ ...containerStyle(index), textStyle: "none", color: "inherit" }}
                      onClick={() => setSelectedContainer(index)}
                    >
                      <Tag
                        style={{
                          margin: 0,
                          top: -30,
                          position: "absolute",
                          alignSelf: "end",
                        }}
                        icon={tagProps.icon}
                        color={tagProps.color}
                      >
                        {currentStatus}
                      </Tag>
                      <h3>Timbangan {index + 1}</h3>
                      <p>
                        {index === 0
                          ? selectedWeight1?.weight
                          : selectedWeight2?.weight}{" "}
                        Kg
                      </p>
                    </button>
                  );
                })}
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

Process.propTypes = {
  setOpenProcess: PropTypes.func,
  onSelectedPallet: PropTypes.func,
  selectionIndex: PropTypes.any,
  handleOkProcess: PropTypes.func,
  openProcess: PropTypes.bool,
};

export default Process;
